<template>
  <validation-observer
    ref="resourceSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      :id="admissionScoreTypeName"
      :ref="admissionScoreTypeName"
      body-class="position-static"
      centered
      size="lg"
      title="Thêm điểm"
      :no-close-on-backdrop="true"
      @hide="onHide"
    >
      <b-row>
        <span class="text-danger ml-1 mb-1">Với điểm học bạ nhập điểm từng môn học của học kỳ I năm học lớp 12.</span>
        <b-col cols="12">
          <b-form
            ref="formRef"
            :style="{height: trHeight}"
          >
            <b-row
              v-for="(item, index) in scoreResources"
              :id="item.id"
              :key="item.id"
              ref="row"
            >
              <b-col md="6">
                <b-form-group label-for="admissionSubjectId">
                  <template v-slot:label>
                    Môn học <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Môn học"
                    rules="required"
                  >
                    <v-select
                      id="admissionSubjectId"
                      v-model="item.admissionSubjectId"
                      label="label"
                      :options="dataListSubject"
                      :reduce="option => option.value"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="score">
                  <template v-slot:label>
                    Điểm số
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Điểm số"
                    rules="required"
                  >
                    <b-form-input
                      id="score"
                      v-model="item.score"
                      name="score"
                      type="number"
                      placeholder="Điểm số"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                lg="2"
                md="2"
                class="mb-50"
              >
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2"
                  @click="removeItem(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Xóa</span>
                </b-button>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
            </b-row>
          </b-form>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            @click="repeatAgain"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            <span>Thêm mới</span>
          </b-button>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :disabled="invalid || scoreResources.length === 0"
            variant="primary"
            class="mr-1"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide(admissionScoreTypeName)"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        no-wrap
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton, BCol, BForm, BFormGroup, BFormInput, BModal, BOverlay, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightTransition } from '@core/mixins/ui/transition'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@core/utils/validations/validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUser } from '@/auth/utils'

export default {
  name: 'AssignPermissionResource',
  directives: {
    Ripple,
  },
  components: {
    BFormInput,
    BModal,
    BOverlay,
    BButton,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    admissionScoreTypeId: {
      type: Number,
      default: undefined,
    },
    admissionScoreTypeName: {
      type: String,
      default: undefined,
    },
  },
  mixins: [heightTransition],
  data() {
    return {
      isLoading: false,
      currentUser: getUser(),
      scoreResources: [{
        id: 1,
        score: null,
        admissionSubjectId: null,
        applicantStudentId: getUser().id,
        admissionScoreTypeId: this.admissionScoreTypeId,
        status: 1,
        orderNo: 1,
      }],
      nextId: 2,
      required,
    }
  },
  computed: {
    ...mapGetters({
      dataListSubject: 'applicantStudent/dataListSubject',
    }),
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    ...mapActions({
      createAcademicTranscriptScore: 'academicTranscriptScore/create',
      getListSubject: 'applicantStudent/getListSubject',
    }),
    repeatAgain() {
      this.scoreResources.push({
        id: this.nextId += this.nextId,
        score: null,
        admissionSubjectId: null,
        applicantStudentId: getUser().id,
        admissionScoreTypeId: this.admissionScoreTypeId,
        status: 1,
        orderNo: 1,
      })
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.scoreResources.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs[this.admissionScoreTypeName].scrollHeight)
      })
    },
    onHide() {
      this.scoreResources = [{
        id: 1,
        score: null,
        admissionSubjectId: null,
        applicantStudentId: getUser().id,
        admissionScoreTypeId: this.admissionScoreTypeId,
        status: 1,
        orderNo: 1,
      }]
      this.nextId = 2
    },
    async onSave() {
      const valid = this.$refs
        .resourceSaveFormRef
        .validate()
      if (valid && this.scoreResources.length > 0) {
        this.isLoading = true
        try {
          const response = await this.createAcademicTranscriptScore(this.scoreResources)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
